var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "url(#paint0_linear_490_5582)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6875 29.5625V27.6875H26.6562V29.5625H23.1719L23.1719 39H21.1719L21.1719 29.5625H17.6875ZM33.1019 39.2188C29.7425 39.2188 27.2034 36.6953 27.1956 33.3438C27.2034 29.9922 29.7425 27.4688 33.1019 27.4688C36.4691 27.4688 39.0159 29.9922 39.0081 33.3438C39.0159 36.6953 36.4691 39.2188 33.1019 39.2188ZM33.1019 37.3281C35.3831 37.3203 36.9925 35.6719 36.9925 33.3438C36.9925 31.0156 35.3831 29.3672 33.1019 29.3594C30.8284 29.3672 29.2191 31.0156 29.2269 33.3438C29.2191 35.6719 30.8284 37.3203 33.1019 37.3281ZM40.3913 39V27.6875H44.1256C46.6491 27.6875 48.3678 29.1641 48.3756 31.3281C48.3678 33.4922 46.6491 34.9688 44.1256 34.9688H42.3913V39H40.3913ZM42.3913 33.1406H44.1413C45.5241 33.1328 46.3522 32.4531 46.3444 31.3281C46.3522 30.1953 45.5241 29.5234 44.1413 29.5156H42.3913V33.1406Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_490_5582",
    x1: -13.5884,
    y1: 53.5374,
    x2: 85.0425,
    y2: 2.34756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BF93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DA5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop);
export default __webpack_public_path__ + "static/media/icon_top.e5b63e304bb6ee8860d0bff2757d784c.svg";
export { ForwardRef as ReactComponent };